module.exports = __webpack_public_path__ + "d2a947943f7a82e9b8d956dec6081331.mp3";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/fantastisch.mp3
// module id = 90
// module chunks = 0